import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './TopHighlights.css';
import ipadImg from '../../assets/TopHighligths/ipads.png';
import macImg from '../../assets/TopHighligths/mac.png';
import onePlusImg from '../../assets/TopHighligths/OnePlus.png';
import accessoriesImg from '../../assets/TopHighligths/iphoneaccess.png';

const TopHighlights = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const handleClick = (path) => {
    if (path === 'coming-soon') {
      setShowPopup(true);
    } else {
      navigate(path);
    }
  };

  const highlights = [
    {
      id: 1,
      image: ipadImg,
      title: 'iPad',
      subtitle: 'An iPad for everything you do',
      path: '/applestore/products-list/ipad'
    },
    {
      id: 2,
      image: macImg,
      title: 'MacBook Pro',
      subtitle: 'Supercharged by M4/M5',
      path: '/applestore/products-list/mac'
    },
    {
      id: 3,
      image: onePlusImg,
      title: 'OnePlus',
      subtitle: 'All the latest, One Powerful Experience',
      path: '/oneplusstore'
    },
    {
      id: 4,
      image: accessoriesImg,
      title: 'Shop Accessories',
      subtitle: 'iPhone . iPad . Watch . MacBook',
      path: '/accessories'
    }
  ];

  return (
    <>
      <section className="top-highlights">
        <div className="highlights-grid">
          {highlights.map((item) => (
            <div
              key={item.id}
              className="highlight-card"
              onClick={() => handleClick(item.path)}
            >
              <div className="highlight-content">
                <h3 className="highlight-title">{item.title}</h3>
                <p className="highlight-subtitle">{item.subtitle}</p>
              </div>
              <div className="highlight-image">
                <img src={item.image} alt={item.title} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Coming Soon</h2>
            <p>OnePlus products will be available soon. Stay tuned!</p>
            <button onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default TopHighlights;
